<ion-content>
  <div class="d-flex align-items-center justify-content-center w-100 h-100 p-4 flex-column">
    @if (!showSuccess) {
      <div class="card-body m-0 p-0">
        <h2 class="card-title mt-3 font-weight-bold">Reset Password</h2>
        <p>Enter your new password below.</p>
        <sm-password-requirements [passwordControl]="resetPasswordForm.get('newPassword')"></sm-password-requirements>
        <form #form="ngForm" (keyup.enter)="submit()" [formGroup]="resetPasswordForm" novalidate>
          <div class="mb-3">
            <ion-item class="no-inner-padding custom-input--login">
              <ion-label class="mt-0 label-form" position="stacked">New Password</ion-label>
              <ion-input class="input-field" formControlName="newPassword" type="password"></ion-input>
            </ion-item>
            <sm-validation [formGroup]="resetPasswordForm" [form]="form" controlName="newPassword"></sm-validation>
          </div>
          <div class="mb-3">
            <ion-item class="no-inner-padding custom-input--login">
              <ion-label class="mt-0 label-form" position="stacked">New Password Confirmation</ion-label>
              <ion-input class="input-field" formControlName="newPasswordConfirmation" type="password"></ion-input>
            </ion-item>
            <sm-validation [formGroup]="resetPasswordForm" [form]="form" controlName="newPasswordConfirmation"></sm-validation>
          </div>
          <ion-button (click)="submit()" [disabled]="submitting" expand="full" type="submit">Reset Password</ion-button>
        </form>
        <ion-button color="light" expand="full" routerLink="/login"> Back to login</ion-button>
      </div>
    }
    @if (showSuccess) {
      <div class="card-body m-0 p-0">
        <h2 class="card-title mt-3 font-weight-bold">Password reset</h2>
        <p>
          Your password has been reset. You may now <a class="link" routerLink="/login">return to the login page</a> and log in.
        </p>
      </div>
    }
  </div>

</ion-content>
